var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLeftFollow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2396 3.44129C16.2396 3.44129 14.5113 6 14.0117 6.5C14.0117 6.5 13.5121 5 13.2909 4.38981C13.0698 3.77963 12.4907 3.14523 11.8166 2.49276C11.1356 1.83363 11.0139 1.5 9.85082 1.06997C8.68774 0.639947 8.35321 0.780922 7.39361 0.59571C7.39361 0.59571 6.5172 0.5 5.91928 0.59571C5.32135 0.691421 4.93639 1.06997 4.93639 1.06997L3.9535 1.54424L2.97062 2.49276L2.47917 3.44129L1.49629 5.8126L0.513399 9.13244C0.513399 9.13244 0.0695375 10.8513 0.0219555 11.978C-0.0410834 13.4708 0.00557394 14.0442 0.513399 15.7721C1.02122 17.5 2.47917 20.0405 2.47917 20.0405C2.47917 20.0405 3.46206 21.4375 4.01903 22C4.576 22.5625 5.42783 23.8346 5.42783 23.8346L8.37649 26.6802C8.37649 26.6802 10.0569 28.1183 11.3252 28.5772L15.2567 30L16.2396 28.1029L18.6968 24.7831L21.6455 21.9375C21.6455 21.9375 23.7143 19.8798 24.5941 18.6177C25.474 17.3556 27.0513 13.8751 27.0513 13.8751L29.0171 9.13244C29.3447 7.86774 30 5.05378 30 3.91555C30 2.77732 29.5165 2.0491 29.0171 1.54424C28.5177 1.03938 25.1648 0.121448 24.1978 0.121448C23.2308 0.121448 21.2967 -0.360485 19.6797 0.59571C18.0627 1.55191 16.731 2.49276 16.2396 3.44129Z",
    fill: "#F45545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLeftFollow);
export default __webpack_public_path__ + "static/media/icon_left_follow.57dd3b0ca9d71e9611da8836b5100f91.svg";
export { ForwardRef as ReactComponent };